import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maschinen-home',
  templateUrl: './maschinen-home.component.html',
  styleUrls: ['./maschinen-home.component.scss']
})
export class MaschinenHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
